<template>
    <div>
        <v-toolbar flat color="white">
            <v-toolbar-title>{{$t('extracurriculares.periodicity.page_title')}}</v-toolbar-title>
            <v-divider
                class="mx-2"
                inset
                vertical
            ></v-divider>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="500px">
                <template v-slot:activator="{ on }">
                    <v-btn color="primary" dark class="mb-2" v-on="on">{{$t('extracurriculares.periodicity.new_type')}}</v-btn>
                </template>
                <v-card>
                    <v-card-title>
                        <span v-show="!editingPeriodicity" class="headline">{{$t('extracurriculares.periodicity.new_type')}}</span>
                        <span v-show="editingPeriodicity" class="headline">{{$t('extracurriculares.periodicity.edit_type')}}</span>
                    </v-card-title>

                    <v-card-text>

                        <text-input
                          :form="form"
                          :label="$t('extracurriculares.periodicity.form.name')"
                          :v-errors="errors"
                          :value.sync="form.name"
                          name="name"
                          v-validate="'required'"
                        ></text-input>

                        <number-input
                          :form="form"
                          :label="$t('extracurriculares.periodicity.form.number')"
                          :v-errors="errors"
                          :value.sync="form.number"
                          name="number"
                        ></number-input>

                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" flat @click="close">{{$t('extracurriculares.periodicity.form.cancel')}}</v-btn>
                        <v-btn v-if="!editingPeriodicity" color="blue darken-1" flat @click="savePeriodicity">{{$t('extracurriculares.periodicity.form.save')}}</v-btn>
                        <v-btn v-else color="blue darken-1" flat @click="updatePeriodicity">{{$t('extracurriculares.periodicity.form.update')}}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-toolbar>
        <v-data-table
            :headers="headers"
            :items="periodicity"
            :loading="loadingTable"
            class="elevation-1"
        >
            <template slot="items" slot-scope="props">
                <td class="text-xs-center">{{ props.item.name }}</td>
                <td class="text-xs-center">{{ props.item.number }}</td>
                <td class="text-xs-center">
                  <v-tooltip top>
                    <v-icon
                      medium
                      class="mr-2"
                      @click="editPeriodicity(props.item.id)"
                      slot="activator"
                    >
                      edit
                    </v-icon>
                    <span>{{$t('extracurriculares.periodicity.edit')}}</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <v-icon
                      medium
                      class="mr-2"
                      @click="deletePeriodicity(props.item.id)"
                      slot="activator"
                    >
                      delete
                    </v-icon>
                    <span>{{$t('extracurriculares.periodicity.delete')}}</span>
                  </v-tooltip>
                </td>
            </template>
        </v-data-table>
    </div>
</template>

<script>
import axios from 'axios'
import Form from 'vform';
import FileUpload from 'vue-upload-component'
export default {
  name: 'enrollments-show-view',
  components: {
    FileUpload,
  },
  data() {
    return {
      headers: [
        { text: this.$t('extracurriculares.periodicity.form.name'), align: 'center', value: 'name' },
        { text: this.$t('extracurriculares.periodicity.form.number'), align: 'center', value: 'number' },
        { text: this.$t('extracurriculares.periodicity.form.actions'), align: 'center', value: 'start_date', sortable: false }
      ],
      periodicity: [],
      typesItems: [],
      editedIndex: -1,
      isLoading: false,
      loadingTable: false,
      dialog: false,
      form: new Form({
        name: '',
        number: ''
      }),
      showSucessMessage: false,
      editingPeriodicity: false,
      userNameMaxLength: 60,
      entries: [],
      teacherFound: {},
      files: [],
      image_to_edit: null
    }
  },
  computed: {
    periodicityResult() {
      return this.entries.map(user => {
        user.name.length > this.userNameMaxLength
          ? user.name.slice(0, this.userNameMaxLength) + '...'
          : user.name

        return Object.assign({}, user)
      })
    }
  },
  watch: {
    dialog(val) {
      val || this.close()
    }
  },
  created() {
    this.getPeriodicity()
  },
  methods: {
    async getPeriodicity() {
      this.loadingTable = true;
      let { data } = await axios.get('/api/extracurriculares/periodicity')
      this.periodicity = data;
      this.loadingTable = false;
    },
    close() {
      this.form = new Form({
        name: '',
        number: ''
      })
      this.dialog = false
      this.editingPeriodicity = false
      this.entries = []
      this.teacherFound = {}
    },
    async savePeriodicity() {
      if (await this.formHasErrors()) return

      const result = await this.form.post('/api/extracurriculares/periodicity', this.form)

      if (result.status === 200) {
        this.getPeriodicity()
        this.$store.dispatch('responseMessage', {
          type: 'success',
          text: this.$t('extracurriculares.periodicity.messages.saved_ok'),
          modal: false
        })
      }

      this.close()
    },
    editPeriodicity(id_periodicity) {
      const PeriodicityToEdit = this.periodicity.filter(type => type.id === id_periodicity)[0];
      this.editingPeriodicity = true;
      this.dialog = true;
      this.form = new Form({
        name: PeriodicityToEdit.name,
        number: PeriodicityToEdit.number,
        id: PeriodicityToEdit.id
      });

    },
    deletePeriodicity(id_periodicity) {
      axios.delete(`/api/extracurriculares/periodicity/${id_periodicity}`)
        .then(resp => {
          if (resp.status === 200) {
            this.periodicity = this.periodicity;
          }
        })
        .catch(error => console.log(error));
    },
    updatePeriodicity() {

      this.form.put('/api/extracurriculares/periodicity')
        .then(resp => {
          if (resp.status === 200) {
              this.getPeriodicity()
              this.close()
              this.editingPeriodicity = false;
          }
        })
        .catch(error => console.log(error));
    },
    handlePeriodicity(id_periodicity, status) {
      axios.put('/api/extracurriculares/periodicity', { id: id_periodicity, status: !status })
        .then(resp => {
          if (resp.status === 200) {
            this.periodicity = this.periodicity.map(periodi => {
              if (periodi.id === id_periodicity) {
                periodi.status = !status;
              }
              return periodi;
            })
          }
        })
    },
    onlyNumbers($event) {
        let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
        if(keyCode == 45) { //This is a code por - (minus sign)
            $event.preventDefault();
        }
    },
    inputFile(newFile, oldFile) {
      if (newFile && !oldFile) {
        // add
        console.log('add', newFile)
      }
      if (newFile && oldFile) {
        // update
        console.log('update', newFile)
      }
      if (!newFile && oldFile) {
        // remove
        console.log('remove', oldFile)
      }
    },
    inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
          return prevent()
        }

        if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
          return prevent()
        }
      }
    }
  }
}
</script>
<style>
.center {
  text-align: center;
  vertical-align: middle;
  justify-content: center;
  align-content: center;
  align-items: center;
}
.editable_image {
  display: flex;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/extracurriculares/manage_columbus/periodicity.vue